module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/eb70d68d689991df420ca0511d609e46.png";